import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { SnackBarService } from 'src/app/services/snack-bar.service';
import { OrderService, OrdersListDto } from 'src/generated_client';

@Component({
  selector: 'app-recent-orders',
  templateUrl: './recent-orders.component.html',
  styleUrls: ['./recent-orders.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class RecentOrdersComponent implements OnInit {

  displayedColumns: string[] = ['id', 'store', 'user', 'address', 'status', 'payment', 'time', 'action'];
  lastFiftyOrders: OrdersListDto[] = [];

  constructor(
    public orderService: OrderService,
    public snackBar: SnackBarService,
    private router: Router
  ) { }

  ngOnInit() {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.orderService.apiOrderLastFiftyGet().subscribe(response => {
      this.lastFiftyOrders = response;
      console.log(response)
    })
  }

  refreshOrders() {
    this.router.navigate(['admin-home']);
  }

  cancelOrder(id: number) {
    this.orderService.apiOrderRejectOrderPut(id).subscribe(response => {
      this.snackBar.openSnackBar('La orden fue anulada con éxito.', 'Aceptar');
      this.router.navigate(['admin-home']);
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y la orden no pudo anularse.', 'Aceptar');
    })
  }

  confirmOrder(id: number) {
    this.orderService.apiOrderConfirmOrderPut(id).subscribe(response => {
      this.snackBar.openSnackBar('La orden fue aceptada.', 'Aceptar');
      this.router.navigate(['admin-home']);
    }, error => {
      this.snackBar.openSnackBar('Ocurrió un error y la orden no pudo aceptarse.', 'Aceptar');
    })
  }

  printTicket(id: number) {

  }

  getTextColor(status: number) {
    switch (status) {
      case 0: {
        return 'grey-text';
      }
      case 1: {
        return 'green-text';
      }
      case 2: {
        return 'red-text';
      }
      case 3: {
        return 'yellow-text';
      }
      case 4: {
        return 'red-text';
      }
      case 5: {
        return 'yellow-text';
      }
      case 6: {
        return 'green-text';
      }
      case 7: {
        return 'yellow-text';
      }
      case 8: {
        return 'red-text';
      }
    }
    return ''
  }

}